import React, { Component, Fragment } from 'react'
import { Checkbox } from '../../legacy-design-system/checkbox'
import { ConfirmationDialog } from '../../legacy-design-system/modal'
import { FormattedMessage } from 'react-intl'

export const checkboxTestId = 'aliasCheckboxTestId'

interface State {
  readonly confirmIsOpen: boolean
}

interface Props {
  readonly savedAlias?: string
  readonly label: string
  readonly value: boolean
  readonly onChange: (value: boolean) => void
}

export class SubstatusAliasCheckbox extends Component<Props> {
  public readonly state: State = {
    confirmIsOpen: false
  }

  public render() {
    const { savedAlias, label, value, onChange } = this.props

    return (
      <Fragment>
        <Checkbox
          id="detail_enableSubstatusAliasSettings_checkbox"
          label={label as string}
          value={value}
          onChange={(value) => {
            if (!value && savedAlias) {
              this.setState({ confirmIsOpen: true })
            } else if (!value && !savedAlias) {
              onChange(false)
            } else {
              onChange(true)
            }
          }}
          data-testid={checkboxTestId}
        />
        <ConfirmationDialog
          size="small"
          isOpen={this.state.confirmIsOpen}
          renderBody={() => (
            <FormattedMessage
              id="detail_removeStatusSubstatusAlias"
              values={{
                alias: <b>{savedAlias}</b>,
                default: (
                  <FormattedMessage id="detail_vulnerabilitySubstatus_other">
                    {(text) => <b>{text}</b>}
                  </FormattedMessage>
                )
              }}
            />
          )}
          renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
          renderTitle={() => <FormattedMessage id="title_removeOption" />}
          renderConfirmMessage={() => <FormattedMessage id="action_remove" />}
          onCancel={this.closeConfirmation}
          onConfirm={() => {
            onChange(false)
            this.closeConfirmation()
          }}
        />
      </Fragment>
    )
  }
  private closeConfirmation = () => this.setState({ confirmIsOpen: false })
}
